<template>
  <v-autocomplete
    autocomplete="off"
    v-model="selectedVendorUUID"
    :label="$t('components.selectors.vendorSelector.manufacturerName')"
    :items="vendorOptions"
    item-value="uuid"
    item-text="name"
    :search-input.sync="vendorSearch"
    color="primary"
    @input.native="loadVendors($event, $data)"
    @keydown.enter.native="addVendor(vendorSearch)"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            v-html="
              $t(
                'components.selectors.vendorSelector.noResultsMatchingPressEnterToCreateANewOne',
                { vendorSearch: vendorSearch }
              )
            "
          >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/utils/api";
import debounce from "@/plugins/debounce";

export default {
  name: "VendorSelector",
  props: ["vendor_uuid", "initial_data", "rules"],
  data: () => ({
    vendorSearch: null,
    vendorOptions: [],
    forceUpdate: 0,
  }),
  computed: {
    selectedVendorUUID: {
      get: function () {
        return this.vendor_uuid;
      },
      set: function (value) {
        this.$emit("update:vendor_uuid", value);
        this.$emit(
          "update:initial_data",
          this.vendorOptions.find((el) => el.uuid === value)
        );
      },
    },
  },
  created() {
    if (this.initial_data) {
      this.vendorOptions.push(this.initial_data);
      this.selectedVendorUUID = this.initial_data.uuid;
    }
    this.loadVendors(null, this);
  },
  watch: {
    vendorSearch(newValue, oldValue) {
      if (newValue === "") {
        this.selectedVendorUUID = null;
        this.vendorSearch = null;
      }
    },
  },
  methods: {
    filterDuplicates(val) {
      return !this.vendorOptions.find((element) => element.name === val);
    },

    loadVendors: debounce((event, self) => {
      self.vendorSearch = self.vendorSearch ? self.vendorSearch : "";
      api.vendorAutocomplete(self.vendorSearch).then((resp) => {
        resp.data.results = [
          ...new Map(
            resp.data.results.map((item) => [item.name, item])
          ).values(),
        ];
        resp.data.results.forEach((element) => {
          self.vendorOptions.push(element);
        });
      });
    }, 300),
    addVendor: function (val) {
      if (val === null) {
        return;
      }
      api.vendorAutocomplete(val).then((resp) => {
        var improvidedUUID = this.vendorOptions.length;
        if (resp.data.count === 0 && this.filterDuplicates(val)) {
          this.vendorOptions.push({
            uuid: improvidedUUID,
            name: val,
          });
          this.selectedVendorUUID = improvidedUUID;
        }
      });
    },
  },
};
</script>

<style scoped></style>
